import { render, staticRenderFns } from "./CreateCompanyClientEmployee.vue?vue&type=template&id=db1a80c2&scoped=true"
import script from "./CreateCompanyClientEmployee.vue?vue&type=script&lang=js"
export * from "./CreateCompanyClientEmployee.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyClientEmployee.vue?vue&type=style&index=0&id=db1a80c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1a80c2",
  null
  
)

export default component.exports